import type { DataInputItem } from "./components/CXAutomationApiSetupSection/components/DataInputRow";
import type { RequestRow } from "./components/CXAutomationApiSetupSection/components/RequestKeyValueRow";

export type RequestTabId = "parameters" | "headers" | "body";

export type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

export interface CXAutomationFormState {
  automationName: string;
  description: string;
  method: HttpMethod;
  urlMarkdown: string;
  dataInputs: DataInputItem[];
  requestRowsByTab: Record<RequestTabId, RequestRow[]>;
}

export const createEmptyAutomationFormState = (): CXAutomationFormState => ({
  automationName: "",
  description: "",
  method: "GET",
  urlMarkdown: "",
  dataInputs: [],
  requestRowsByTab: { parameters: [], headers: [], body: [] },
});
